import React from "react";
import { Card, PageHeader } from "@pericles/framework-frontend";

import { useAuth } from "../hooks/auth";

import { PageShell } from "./ui";

export function TenantSelectScreen(): JSX.Element {
  const { tenants, setActiveTenant } = useAuth();
  const [error, setError] = React.useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSelect = async (tenantId: string) => {
    setError(null);
    setIsSubmitting(true);
    try {
      await setActiveTenant(tenantId);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to select tenant");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageShell className="min-h-screen items-center justify-center bg-slate-50">
      <Card className="w-full max-w-lg">
        <div className="flex flex-col gap-6 p-6">
          <PageHeader title="Select a tenant" subtitle="Choose the tenant you want to work on." />
          <div className="flex flex-col gap-3">
            {tenants.map((tenant) => (
              <button
                key={tenant.id}
                type="button"
                className="flex items-center justify-between rounded-lg border border-border bg-white px-4 py-3 text-left text-sm font-medium shadow-soft transition hover:border-primary"
                onClick={() => handleSelect(tenant.id)}
                disabled={isSubmitting}
              >
                <span>{tenant.name}</span>
                <span className="text-xs text-muted-foreground">Select</span>
              </button>
            ))}
          </div>
          {error ? <p className="text-sm text-red-600">{error}</p> : null}
        </div>
      </Card>
    </PageShell>
  );
}
